import { motion } from "framer-motion";

export const SectionHeading = ({ kicker, title, copy, dark = false, align = "left", chapter }) => (
  <motion.div
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
    className={`relative max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    data-testid={`heading-${kicker?.toLowerCase().replace(/[^a-z]+/g, "-")}`}
  >
    {chapter && (
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute -top-12 right-0 select-none font-serif text-7xl sm:text-8xl ${
          dark ? "text-white/[0.06]" : "text-atlantic/[0.06]"
        }`}
      >
        {chapter}
      </span>
    )}
    <p className={`text-xs font-semibold uppercase tracking-[0.28em] ${dark ? "text-gold" : "text-ocean"}`}>
      {kicker}
    </p>
    <h2 className={`mt-4 font-serif text-3xl leading-tight tracking-tight sm:text-4xl lg:text-[2.75rem] ${dark ? "text-white" : "text-atlantic"}`}>
      {title}
    </h2>
    {copy && (
      <p className={`mt-6 text-base leading-relaxed sm:text-lg ${dark ? "text-white/70" : "text-slate-600"}`}>
        {copy}
      </p>
    )}
  </motion.div>
);
